module.exports = __webpack_public_path__ + "img/recertificacion.8e4476e4.jpg";